import { DatePipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

import { ConfigService } from '../services/config/config.service';

@Pipe({ name: 'appDateFromConfig' })
export class DateFromConfigPipe extends DatePipe implements PipeTransform {
    constructor(@Inject(LOCALE_ID) locale: string, private configService: ConfigService) {
        super(locale);
    }

    transform(value: any, property: string, timezone?: string, locale?: string): string | null {
        const format = this.configService.config[property] as string;
        if (format === undefined) {
            throw new Error(`Property "${property}" is not defined in config.json, RawConfig or Config!`);
        }
        return super.transform(value, format, timezone, locale);
    }
}
